import React from 'react';
import { TableContentWithoutEdit } from '../../Common/Table/tableContent';

class CreatePDF extends React.Component {
    render() {
        const { data, grnNUmbers, rowNames, searchData } = this.props;

        return (
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px', borderBottom: '2px solid #333', paddingBottom: '10px' }}>
                    <h2 style={{ margin: '0', fontSize: '24px', fontWeight: 'bold' }}>
                        Goods Receive Note Report
                    </h2>
                </div>

                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(4, 1fr)', 
                    gap: '15px',
                    marginBottom: '30px',
                    padding: '15px',
                    backgroundColor: '#ffffffff',
                    borderRadius: '5px'
                }}>
                    <div>
                        <strong style={{ display: 'block', marginBottom: '5px' }}>Group:</strong>
                        <span>{searchData.group || 'N/A'}</span>
                    </div>
                    <div>
                        <strong style={{ display: 'block', marginBottom: '5px' }}>Operation Entity:</strong>
                        <span>{searchData.estate || 'N/A'}</span>
                    </div>
                    <div>
                        <strong style={{ display: 'block', marginBottom: '5px' }}>Weigh Points:</strong>
                        <span>{searchData.division || 'All'}</span>
                    </div>
                    <div>
                        <strong style={{ display: 'block', marginBottom: '5px' }}>Date:</strong>
                        <span>{searchData.date || 'N/A'}</span>
                    </div>
                </div>

                {grnNUmbers && grnNUmbers.map((grnNumber, index) => {
                    const grnData = data[grnNumber];
                    if (!grnData || grnData.length === 0) return null;

                    return (
                        <div key={index} style={{ 
                            marginBottom: '40px', 
                            pageBreakInside: 'avoid',
                            overflow: 'hidden'
                        }}>
                            <div style={{ 
                                display: 'grid', 
                                gridTemplateColumns: 'repeat(5, 1fr)', 
                                backgroundColor: '#ffffffff',
                                padding: '12px',
                                gap: '10px'
                            }}>
                                <div>
                                    <strong style={{ display: 'block', fontSize: '11px', marginBottom: '4px' }}>
                                        GRN Number
                                    </strong>
                                    <span style={{ fontSize: '12px', wordBreak: 'break-word' }}>
                                        {grnNumber}
                                    </span>
                                </div>
                                <div>
                                    <strong style={{ display: 'block', fontSize: '11px', marginBottom: '4px' }}>
                                        WeighPoint Name
                                    </strong>
                                    <span style={{ fontSize: '12px', wordBreak: 'break-word' }}>
                                        {grnData[0].collectionPointName || 'N/A'}
                                    </span>
                                </div>
                                <div>
                                    <strong style={{ display: 'block', fontSize: '11px', marginBottom: '4px' }}>
                                        Received Estate
                                    </strong>
                                    <span style={{ fontSize: '12px', wordBreak: 'break-word' }}>
                                        {grnData[0].transferedEstate || 'N/A'}
                                    </span>
                                </div>
                                <div>
                                    <strong style={{ display: 'block', fontSize: '11px', marginBottom: '4px' }}>
                                        Received Division
                                    </strong>
                                    <span style={{ fontSize: '12px', wordBreak: 'break-word' }}>
                                        {grnData[0].transferedDivision || 'N/A'}
                                    </span>
                                </div>
                                <div>
                                    <strong style={{ display: 'block', fontSize: '11px', marginBottom: '4px' }}>
                                        Transfer Note
                                    </strong>
                                    <span style={{ fontSize: '12px', wordBreak: 'break-word' }}>
                                        {grnData[0].transferNote || 'N/A'}
                                    </span>
                                </div>
                            </div>

                            <div style={{ padding: '5px' }}>
                                <table style={{ 
                                    width: '100%', 
                                    borderCollapse: 'collapse',
                                    fontSize: '14px',
                                    marginTop: '10px'
                                }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#ffffffff' }}>
                                            <th style={{ 
                                                padding: '15px', 
                                                textAlign: 'left',
                                                fontWeight: 'bold',
                                                borderBottom: '2px solid #333'
                                            }}>
                                                Field
                                            </th>
                                            <th style={{ 
                                                padding: '15px', 
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                borderBottom: '2px solid #333'
                                            }}>
                                                Total Amount<br/>(Kg)
                                            </th>
                                            <th style={{ 
                                                padding: '15px', 
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                borderBottom: '2px solid #333'
                                            }}>
                                                Deduction<br/>(Kg)
                                            </th>
                                            <th style={{ 
                                                padding: '15px', 
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                borderBottom: '2px solid #333'
                                            }}>
                                                Net Amount<br/>(Kg)
                                            </th>
                                            <th style={{ 
                                                padding: '15px', 
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                                borderBottom: '2px solid #333'
                                            }}>
                                                Bag Count
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {grnData.map((row, rowIndex) => (
                                            <tr key={rowIndex} style={{ 
                                                backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#ffffffff' 
                                            }}>
                                                <td style={{ 
                                                    padding: '12px',
                                                    wordBreak: 'break-word',
                                                    borderBottom: '1px solid #eee'
                                                }}>
                                                    {row.fieldName || '-'}
                                                </td>
                                                <td style={{ 
                                                    padding: '12px', 
                                                    textAlign: 'right',
                                                    borderBottom: '1px solid #eee'
                                                }}>
                                                    {row.totalAmount || '0'}
                                                </td>
                                                <td style={{ 
                                                    padding: '12px', 
                                                    textAlign: 'right',
                                                    borderBottom: '1px solid #eee'
                                                }}>
                                                    {row.deduction || '0'}
                                                </td>
                                                <td style={{ 
                                                    padding: '12px', 
                                                    textAlign: 'right',
                                                    borderBottom: '1px solid #eee'
                                                }}>
                                                    {row.netAmount || '0'}
                                                </td>
                                                <td style={{ 
                                                    padding: '12px', 
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #eee'
                                                }}>
                                                    {row.bagCount || '0'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                })}

                <div style={{ 
                    marginTop: '30px', 
                    paddingTop: '10px', 
                    borderTop: '1px solid #ddd',
                    textAlign: 'center',
                    fontSize: '10px',
                    color: '#ffffffff'
                }}>
                    Generated on {new Date().toLocaleString()}
                </div>
            </div>
        );
    }
}

export default CreatePDF;